import { IconPaths } from '_metronic/helpers'
import { RowActions, useModal } from 'app/components'
import { NotificacaoAdminList } from '../../../core/_models'
import { getNotificacaoAdminById } from '../../../core/_requests'
import { NotificacaoDetalheModal } from '../../../components/modal/NotificacaoDetalheModal'

/**
 * Só visualização: esta tela é de auditoria. O detalhe vem do endpoint administrativo, que não
 * marca como lida — quem audita não pode alterar o estado de leitura de outra pessoa.
 */
export const NotificacaoEnviadaActionsCell = ({
  notificacao,
}: {
  notificacao: NotificacaoAdminList
}) => {
  const { showModal } = useModal()

  const abrirNotificacao = () => {
    showModal({
      title: notificacao.titulo,
      content: <NotificacaoDetalheModal />,
      fetchers: { notificacao: () => getNotificacaoAdminById(notificacao.id) },
    })
  }

  return (
    <RowActions
      itemName={`notificação ${notificacao.titulo}`}
      primaryAction={{
        label: 'Ver notificação',
        onClick: abrirNotificacao,
        icon: IconPaths.Search,
      }}
    />
  )
}
